import { Label, TextStyle, TextField } from "@lannister/duplo";

import { ReactComponent as EmptyWallet } from "../../assets/icons/empty-wallet.svg";

import { ValidateNumeric } from "./utils";

const Wallet = ({ form, handleChange}) => {

  return (
        <div style={styles.field}>
            <TextField
                label="Mobile Number"
                value={form.payment_number}
                onChange={handleChange("payment_number")}
                rightIcon={<EmptyWallet />}
                maxLength={19}
                onInput={
                (event) => {
                    ValidateNumeric(event);
                }}
            />
            <Label
                labelText="Enter the phone number associated to your wallet"
                textStyle={TextStyle.BaseMedium}
            />
        </div>
  );
};

const styles = {
  field: {
    flex: 1,
    minWidth: 0,
  },
};

export default Wallet;
